import assetManagement from "./asset-management/asset-management";

export default function (nameController, nameAction, namePage) {
  if (nameController === 'assetmanagement') assetManagement(nameAction, namePage);
}